import { useEffect, useState } from "react";
import keyboardInset, { typing } from "@/hooks/keyboardInset";

/**
 * Phones: the sheet keeps its height; returns how far (px) the composer should lift so it
 * rests on top of the on-screen keyboard. 0 when no keyboard / not a phone.
 */
export default function useKeyboardSheetStyle(active) {
  const [lift, setLift] = useState(0);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!active || !vv) return undefined;
    // Pin the page behind where it was (iOS likes to scroll it when the box is tapped).
    const y = window.scrollY;
    let raf = 0;
    const update = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        if (window.innerWidth >= 640 || !typing()) { setLift(0); return; }
        // Undo iOS's auto-pan so the sheet stays put and only the composer moves.
        if (window.scrollY !== y) window.scrollTo(0, y);
        const kb = keyboardInset();
        setLift(kb < 80 ? 0 : kb);
      });
    };
    const onFocus = () => { update(); setTimeout(update, 120); setTimeout(update, 360); setTimeout(update, 700); };
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    window.addEventListener("focusin", onFocus);
    window.addEventListener("focusout", onFocus);
    return () => {
      cancelAnimationFrame(raf);
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      window.removeEventListener("focusin", onFocus);
      window.removeEventListener("focusout", onFocus);
      setLift(0);
    };
  }, [active]);
  return lift;
}
